const asapDematerialise = [
	{
		key: '',
		text: "Non dématérialisé par l'ordonnateur",
		value: '',
	},
	{
		key: '01',
		text: '01 A éditer par la DGFIP',
		value: '01',
	},
	{
		key: '02',
		text: '02 A déposer sur Chorus Pro par la DGFIP',
		value: '02',
	},
	{
		key: '04',
		text: '04 Pour informer le trésorier',
		value: '04',
	},
];

export default asapDematerialise;
